import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

import DownloadIconPrimary from '../../../../../../assets/icons/DownloadIconPrimary';
import DownloadPdfIcon from '../../../../../../assets/icons/DownloadPdf';
import { useGetCalculationPdfDownloadUrl } from '../../../../../../hooks/api/footprints';
import useNotificationContext from '../../../../../../hooks/notification/useNotificationContext';
import {
  DownloadCalculationPDFErrorCodes,
  DownloadCalculationPDFErrorCodesTranslationKeyMap,
} from '../../../../../../shared/enums/get-calculations-pdf-download-url-error-code';
import { ToastSeverity } from '../../../../../../shared/enums/toast-severity';
import styles from './DownloadCalculationDetails.module.css';

export type DownloadPdfFileButtonProps = {
  footprintId: number;
  pdfPath?: string;
};

const DownloadCalculationDetails = ({ footprintId, pdfPath }: DownloadPdfFileButtonProps) => {
  const { notify } = useNotificationContext();
  const { t } = useTranslation();
  const { refetch: fetchPDFDownloadUrl } = useGetCalculationPdfDownloadUrl(footprintId);

  const handleClick = async () => {
    const { data, isSuccess, error } = await fetchPDFDownloadUrl();
    if (isSuccess && data.downloadUrl) {
      window.open(data.downloadUrl, '_blank');

      return;
    }

    const errorCode = (error as Error)?.message;

    let errorMessage = '';

    if (
      Object.values(DownloadCalculationPDFErrorCodes).includes(
        errorCode as DownloadCalculationPDFErrorCodes,
      )
    ) {
      // It's a known error code, handle it accordingly
      errorMessage = t(
        `toastMessages.downloadCalculationPDFErrors.states.failure.${
          DownloadCalculationPDFErrorCodesTranslationKeyMap[
            errorCode as DownloadCalculationPDFErrorCodes
          ]
        }.detail`,
      );
    } else {
      // It's an unknown error code, show generic error message
      errorMessage = t('toastMessages.downloadPdf.states.failure.detail');
    }

    notify({
      severity: ToastSeverity.ERROR,
      detail: errorMessage,
      life: 3000,
    });
  };

  return (
    <div
      className={`${styles['download-calculation-pdf-button']} flex flex-row align-items-center`}
    >
      <DownloadPdfIcon />
      <Button
        text
        disabled={!pdfPath}
        label={t('footprintDetailsPage.sections.pcfGeneralDetailsSection.downloadPDFButton')}
        className={'bg-transparent flex flex-row-reverse gap-1 text-black-alpha-90 p-1'}
        onClick={handleClick}
        icon={DownloadIconPrimary}
      />
    </div>
  );
};

export default DownloadCalculationDetails;
